export const CHATBOT_BLOCK_NAME = "Chatbot";
export const CHATBOT_BLOCK_DESCRIPTION = "Build an AI-powered chatbot.";
export const CHATBOT_BLOCK_EDITOR_TOOLTIP = "Chatbot";
export const CHATBOT_BLOCK_TAB_CONTENT = "Content";
export const CHATBOT_BLOCK_TAB_DATA = "Data";
export const CHATBOT_BLOCK_TAB_ACTIONS = "Actions";
export const CHATBOT_BLOCK_TAB_EMBED = "Embed";
export const CHATBOT_BLOCK_FIELD_NAME_LABEL = "Chatbot name";
export const CHATBOT_BLOCK_FIELD_NAME_VALUE = "Chatbot";

// Height field
export const CHATBOT_BLOCK_FIELD_HEIGHT_LABEL = "Height";
export const CHATBOT_BLOCK_FIELD_DEFAULT_HEIGHT = "default";

export const CHATBOT_BLOCK_FIELD_PLACEHOLDER_LABEL = "Prompt placeholder";
export const CHATBOT_BLOCK_FIELD_PLACEHOLDER_VALUE = "Ask me anything";
export const CHATBOT_BLOCK_FIELD_DEFAULT_PROMPT_VALUE =
  "Say hello and tell me what you can do.";
export const CHATBOT_BLOCK_FIELD_DEFAULT_MESSAGE_LABEL = "Greeting";
export const CHATBOT_BLOCK_FIELD_DEFAULT_MESSAGE_HELPTEXT_STATIC =
  "This will be the first message the user sees.";
export const CHATBOT_BLOCK_FIELD_DEFAULT_MESSAGE_HELPTEXT_GENERATED =
  "The chatbot will generate the first message the user sees based on its directive and this prompt.";
export const CHATBOT_BLOCK_FIELD_DEFAULT_MESSAGE_VALUE =
  "How can I help you today?";
export const CHATBOT_BLOCK_FIELD_DIRECTIVE_LABEL = "Directive";
export const CHATBOT_BLOCK_FIELD_DIRECTIVE_HELPTEXT =
  "Tell the bot how you’d like it to respond. You can include style, tone, accent, and more.";
export const CHATBOT_BLOCK_FIELD_DIRECTIVE_VALUE =
  "You are an AI chatbot. You are a helpful assistant.";
export const CHATBOT_BLOCK_FIELD_DISCLOSURE_LABEL = "Disclosure message";
export const CHATBOT_BLOCK_FIELD_DISCLOSURE_HELPTEXT =
  "This input accepts markdown links.";
export const CHATBOT_BLOCK_FIELD_DISCLOSURE_VALUE =
  "This is an automated chatbot response. [Learn more](https://zapier.com/legal/terms-of-service)";
export const CHATBOT_BLOCK_FIELD_AUTHENTICATION_LABEL = "OpenAI authentication";
export const CHATBOT_BLOCK_FIELD_AUTHENTICATION_ERROR = `This authentication isn't working.`;
export const CHATBOT_BLOCK_FIELD_AUTHENTICATION_LIST_ARIA_LABEL =
  "List of connected OpenAI authentications";
export const CHATBOT_BLOCK_FIELD_MODEL_LABEL = "Model";
export const CHATBOT_BLOCK_FIELD_MODEL_LIST_ARIA_LABEL =
  "List of available GPT models";
export const CHATBOT_BLOCK_FIELD_MODEL_VALUE = "gpt-3.5-turbo";
export const CHATBOT_BLOCK_FIELD_MODEL_HELPTEXT =
  "Model availability depends on the selected authentication.";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_LABEL =
  "When results are not found from the data source";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_CUSTOM_MESSAGE_LABEL =
  "Custom message";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_CUSTOM_MESSAGE_VALUE =
  "Sorry, I’m not able to provide an answer.";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_LIST_ARIA_LABEL =
  "List of behaviors when no results are found from the data source";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_VALUE = "chatgpt";
export const CHATBOT_BLOCK_FIELD_DATASOURCE_NO_RESULTS_HELPTEXT =
  "This defines the experience when results are not found from the data source.";
export const CHATBOT_BLOCK_FIELD_MAX_TOKENS_LABEL =
  "Max response length (tokens)";
export const CHATBOT_BLOCK_FIELD_MAX_TOKENS_HELPTEXT =
  "The default setting is {{contextLimit}} max tokens used per response for this model.";
export const CHATBOT_BLOCK_FIELD_MAX_TOKENS_HELPTEXT_UPGRADED =
  "Set the max length for individual chatbot responses. The max setting available is the total tokens available for the model: {{contextLimit}}.";
export const CHATBOT_BLOCK_FIELD_CREATIVITY_LABEL = "Creativity";
export const CHATBOT_BLOCK_FIELD_CREATIVITY_HELPTEXT_LEFT = "Predictable";
export const CHATBOT_BLOCK_FIELD_CREATIVITY_HELPTEXT_RIGHT = "Random";
export const CHATBOT_BLOCK_FIELD_CREATIVITY_RESET = "Reset to default";
export const CHATBOT_BLOCK_PANEL_DATA_TITLE = "Connect a custom data source";
export const CHATBOT_BLOCK_PANEL_DATA_DESCRIPTION =
  "Upload a file with your own knowledge to tailor the AI Chatbot responses for your business or project.";
export const CHATBOT_BLOCK_PANEL_DATA_UPGRADE_DETAILS =
  "Current functionality includes the ability to upload one 1MB static text file (.txt, .csv, .json, .pdf, .doc, .docx).";
export const CHATBOT_BLOCK_PANEL_ACTIONS_TITLE =
  "Trigger actions from chatbot responses";
export const CHATBOT_BLOCK_PANEL_ACTIONS_DESCRIPTION =
  "Setup automations that trigger available actions directly in chat.";
export const CHATBOT_BLOCK_PANEL_ACTIONS_ZEROSTATE_ALT_TEXT =
  "User interface screenshot of an input connected to a Zapier action";
